import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useGoogleCalendarEvents = () => {
  return useQuery({
    queryKey: ['google-calendar-events-all'],
    queryFn: async () => {
      console.log('Fetching Google Calendar events...');
      
      const { data, error } = await supabase.functions.invoke(
        'sync-google-calendar'
      );

      if (error) {
        console.error('Error fetching Google Calendar events:', error);
        throw error;
      }

      console.log(`Fetched ${data?.events?.length || 0} Google Calendar events`);
      return data?.events || [];
    },
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
    staleTime: 4 * 60 * 1000, // Consider data stale after 4 minutes
  });
};